import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchWrapper } from "../_helpers";
import { showToastNotification } from "../components/common/ui/NotificationModal/ToastNotication";

// create slice

const resourceForm = {
  title: "",
  url: "",
  photo: "",
  committee: "",
};
const name = "additionalResource";
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();
// const extraReducers = createExtraReducers();
const slice = createSlice({
  name,
  initialState,
  reducers,
  extraReducers: (builder) => {
    createExtraReducers(builder);
  },
  // extraReducers,
});

// exports

export const additionalResourceActions = { ...slice.actions, ...extraActions };
export const additionalResourceReducer = slice.reducer;

// implementation
function createInitialState() {
  return {
    resourceForm: resourceForm,
    getAdditionalResourceListResponse: {},
    createAdditionalResourceResponse: {},
    updateAdditionalResourceResponse: {},
    deleteEventResponse: {},
  };
}

function createReducers() {
  return {
    updateForm,
    resetForm,
  };
  function updateForm(state, action) {
    state.resourceForm = action?.payload;
  }
  function resetForm(state) {
    state.resourceForm = resourceForm;
  }
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_API_URL}`;

  return {
    getAdditionalResourceList: getAdditionalResourceList(),
    createAdditionalResource: createAdditionalResource(),
    updateAdditionalResource: updateAdditionalResource(),
    deleteEvent: deleteEvent(),
    getEventListForCalender: getEventListForCalender(),
  };

  function getAdditionalResourceList() {
    return createAsyncThunk(
      `${name}/getAdditionalResourceList`,
      async (id) =>
        await fetchWrapper.get(`${baseUrl}/additional-resource/committee/${id}`)
    );
  }

  function createAdditionalResource() {
    return createAsyncThunk(
      `${name}/createAdditionalResource`,
      async (payload) => {
        return await fetchWrapper.post(
          `${baseUrl}/additional-resource`,
          payload
        );
      }
    );
  }

  function updateAdditionalResource() {
    return createAsyncThunk(
      `${name}/updateAdditionalResource`,
      async (payload) => {
        return await fetchWrapper.patch(
          `${baseUrl}/additional-resource/${payload?.id}`,
          payload?.formData
        );
      }
    );
  }

  function deleteEvent() {
    return createAsyncThunk(`${name}/deleteEvent`, async (id) => {
      return await fetchWrapper.patch(`${baseUrl}/events/delete/${id}`, {
        status: false,
      });
    });
  }
  function getEventListForCalender() {
    return createAsyncThunk(
      `${name}/getEventListForCalender`,
      async (payload) => {
        return await fetchWrapper.get(
          `${baseUrl}/events/calendar?month=${payload?.month}&year=${payload?.year}`
        );
      }
    );
  }
}

function createExtraReducers(builder) {
  builder
    .addCase(extraActions.getAdditionalResourceList.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.getAdditionalResourceList.fulfilled,
      (state, action) => {
        state.loading = false;
        state.getAdditionalResourceListResponse = action.payload;
      }
    )
    .addCase(
      extraActions.getAdditionalResourceList.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
        showToastNotification(action.error.message, "error");
      }
    )

    //ceate event
    .addCase(extraActions.createAdditionalResource.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.createAdditionalResource.fulfilled,
      (state, action) => {
        state.createAdditionalResourceResponse = action.payload;
        state.loading = false;
      }
    )
    .addCase(
      extraActions.createAdditionalResource.rejected,
      (state, action) => {
        state.error = action.error;
        state.loading = false;
        showToastNotification(action.error.message, "error");
      }
    )

    //update event
    .addCase(extraActions.updateAdditionalResource.pending, (state) => {
      state.error = null;
      state.loading = true;
    })
    .addCase(
      extraActions.updateAdditionalResource.fulfilled,
      (state, action) => {
        state.loading = false;
        state.updateAdditionalResourceResponse = action.payload;
      }
    )
    .addCase(
      extraActions.updateAdditionalResource.rejected,
      (state, action) => {
        state.error = action.error;
        state.loading = false;
        showToastNotification(action.error.message, "error");
      }
    )

    //delete event
    .addCase(extraActions.deleteEvent.pending, (state) => {
      state.error = null;
      state.loading = true;
    })
    .addCase(extraActions.deleteEvent.fulfilled, (state, action) => {
      state.loading = false;
      state.deleteEventResponse = action.payload;
    })
    .addCase(extraActions.deleteEvent.rejected, (state, action) => {
      state.error = action.error;
      state.loading = false;
      showToastNotification(action.error.message, "error");
    })
    //calender
    .addCase(extraActions.getEventListForCalender.pending, (state) => {
      state.error = null;
      state.loading = true;
    })
    .addCase(
      extraActions.getEventListForCalender.fulfilled,
      (state, action) => {
        state.loading = false;
        state.getEventListForCalenderResponse = action.payload;
      }
    )
    .addCase(extraActions.getEventListForCalender.rejected, (state, action) => {
      state.error = action.error;
      state.loading = false;
      showToastNotification(action.error.message, "error");
    });
}
